import { type AnimationState, opaqueHex, type PathElement, parseHex } from "@cva/shared";
import type { ReactNode } from "react";
import { boxStyle, dropShadowCss, joinFilters } from "./styles";

/**
 * Freehand stroke: path data on its own viewBox, stretched onto the box so
 * the stroke (and its width) scales with the element. Always vector, also in
 * PDFs; the highlighter multiplies with what lies below.
 */
export function renderPath(element: PathElement, state: AnimationState): ReactNode {
  const box = boxStyle(element, state);
  const alpha = parseHex(element.color).a;
  const fill = element.fill ? parseHex(element.fill) : null;
  return (
    <div
      key={element.id}
      data-element-id={element.id}
      style={{
        ...box,
        mixBlendMode: element.brush === "highlighter" ? "multiply" : undefined,
        filter: joinFilters(box.filter as string | undefined, dropShadowCss(element.shadow)),
      }}
    >
      <svg
        viewBox={`0 0 ${element.viewBox[0]} ${element.viewBox[1]}`}
        preserveAspectRatio="none"
        width="100%"
        height="100%"
        style={{ position: "absolute", inset: 0, display: "block", overflow: "visible" }}
        aria-hidden="true"
      >
        <path
          d={element.d}
          fill={element.fill && fill ? opaqueHex(element.fill) : "none"}
          fillOpacity={fill && fill.a < 0.999 ? fill.a : undefined}
          stroke={element.strokeWidth > 0 ? opaqueHex(element.color) : "none"}
          strokeOpacity={alpha < 0.999 ? alpha : undefined}
          strokeWidth={element.strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
}
